// 🎯 [New] App Modes System
// 리소스 관리 및 성능 최적화를 위한 전역 앱 모드 상수
export const APP_MODE = {
    NORMAL: 'NORMAL',           // 기본 상태 (모든 기능 활성)
    SUSPENDED: 'SUSPENDED',     // 백그라운드 갱신 중지 (결제, 모달 등)
    HEAVY_TASK: 'HEAVY_TASK'    // 리소스 독점 모드 (GPU/CPU) - 지도 렌더링 중지, GPS 중지
};
